var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-component",
    {
      attrs: {
        title: _vm.$helpers.trans("auth.registerModalTitle"),
        open: _vm.open
      },
      on: {
        close: function($event) {
          return _vm.$emit("update:open", false)
        }
      }
    },
    [
      _c(
        "form-component",
        {
          attrs: { name: "Login", action: "/register", "spam-filter": false },
          on: {
            success: function($event) {
              return _vm.registrationComplete()
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm.$helpers.trans("auth.email")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.email,
                  expression: "user.email"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "email", required: "", name: "email" },
              domProps: { value: _vm.user.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm.$helpers.trans("auth.password")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.password,
                  expression: "user.password"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "password", required: "", name: "password" },
              domProps: { value: _vm.user.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "password", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm.$helpers.trans("auth.passwordConfirmation")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.password_confirmation,
                  expression: "user.password_confirmation"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                required: "",
                name: "password_confirmation"
              },
              domProps: { value: _vm.user.password_confirmation },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.user,
                    "password_confirmation",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm.$helpers.trans("auth.firstname")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.firstname,
                  expression: "user.firstname"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", required: "", name: "firstname" },
              domProps: { value: _vm.user.firstname },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "firstname", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "control-label" }, [
              _vm._v(_vm._s(_vm.$helpers.trans("auth.lastname")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.lastname,
                  expression: "user.lastname"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", required: "", name: "lastname" },
              domProps: { value: _vm.user.lastname },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "lastname", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("div", { staticClass: "invalid-feedback" })
          ])
        ]
      ),
      _vm._v(" "),
      _vm.complete
        ? _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              {
                staticClass: "btn btn-default",
                on: {
                  click: function($event) {
                    return _vm.$emit("update:open", false)
                  }
                }
              },
              [_vm._v("Close")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21d191d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d191d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/package/RF/Member/modals/Register.vue
// module id = 253
// module chunks = 17